import { props, state, resolveObject } from 'cerebral/tags'
import { set, when } from 'cerebral/operators'
import { addResource } from '../actions/manipulateResource'
import createSnackbar from 'modules/App/factories/createSnackbar'

const prepareFiles = () => {
  return function({ state, props }) {
    const { selectedFiles, tags: { showShared } } = state.get('media')
    const files = showShared ? selectedFiles : [props.id]

    files.forEach(id => {
      const path = `media.files.${id}.resources.${props.type}`
      let hasResources = state.get(path)
      if (!hasResources) {
        state.set(path, [])
        hasResources = []
      }

      const hasValue = hasResources.reduce((acc, value) => {
        if (value.toLowerCase() === props.value.toLowerCase()) {
          acc = true
        }
        return acc
      }, false)

      if (!hasValue) state.push(path, props.value)
    })
  }
}

export default [
  function hasValue({ state, props, path }) {
    const resources = state.get(`media.tags.form.resources.${props.type}`)
    if (Object.keys(resources).length > 1) {
      const exists = Object.keys(resources).reduce((acc, key) => {
        const item = resources[key]
        if (!item.isForm) {
          if (item.label.toLowerCase() === props.value.toLowerCase()) {
            acc = true
          }
        }
        return acc
      }, false)
      return exists ? path.true() : path.false()
    }
    return path.false()
  },
  {
    true: [
      createSnackbar(
        resolveObject({
          key: 'bms.media.tagsMenu.tagExists',
          params: resolveObject({
            tag: props`value`
          })
        }),
        'error'
      )
    ],
    false: [
      when(props`pick`),
      {
        true: [
          function({ props, state }) {
            const items = state.get(
              `media.tags.form.resources.${props.type}.form.items`
            )

            state.splice(
              `media.tags.form.resources.${props.type}.form.items`,
              items.indexOf(props.value),
              1
            )
          }
        ],
        false: [set(state`${props`path`}.value`, '')]
      },

      prepareFiles(),
      function({ uuid, state, props }) {
        state.set(`media.tags.form.resources.${props.type}.${uuid.id()}`, {
          label: props.value,
          selected: true
        })
      },
      addResource,
      createSnackbar({ key: 'bms.fieldSaved' }, 'success')
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/addResource.js